import BaseApi from "./baseApi";

class ActivityLogApi extends BaseApi {
  async list(data: Record<string, unknown> | object = {}): Promise<any> {
    return this.API({
      url: "/activity-log/list",
      data,
      method: "post",
    });
  }

  async listByEntity(entityType: string, entityId: string | number): Promise<any> {
    return this.API({
      url: `/activity-log/entity/${entityType}/${entityId}`,
      method: "get",
    });
  }
}

export default ActivityLogApi;
